<header class="header-holder">
  <div>
    <p><a href="#main-content" spbAccessibleLink>Hoppa
      till innehåll</a></p>
    <spb-logo></spb-logo>
  </div>

  <div>
    @if (!environment.production) {
      <button mat-icon-button (click)="this.service.toggleTestMode()">
        <mat-icon>
          {{ service.testMode() ? 'arrow_back_ios' : 'arrow_forward_ios' }}
        </mat-icon>
      </button>
    }

    <spb-toggle-button></spb-toggle-button>
  </div>
</header>